import { IsNotEmpty, IsOptional, IsString } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateEstablishmentTypeDto {
  @ApiProperty({
    type: 'string',
    description: "Code unique du type d'établissement",
    example: 'LYCEE',
  })
  @IsNotEmpty()
  @IsString()
  code!: string

  @ApiProperty({ type: 'string', description: "Nom du type d'établissement", example: 'Lycée' })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({ type: 'string', description: 'Description' })
  @IsOptional()
  @IsString()
  description?: string
}
